"use strict";

import { Button, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { toast } from "react-toastify";

import {
    DEFAULT_STEM_SEPARATION_PROVIDER,
    STEM_SEPARATION_OPTIONS,
} from "./modeOptions.js";
import ReloadVideoDialog from "./ReloadVideoDialog.js";

/**
 * The Upload/Reload video button and its dialog, shared by the Actions and
 * Manage pages. `blocker` (see reloadVideoBlocker) says why the button is
 * disabled; onStarted runs once the new video's run has been requested.
 */
const ReloadVideoButton = ({
    projectId,
    projectName,
    hasVideo,
    blocker,
    defaultStemSeparationProvider = DEFAULT_STEM_SEPARATION_PROVIDER,
    onStarted,
    buttonProps = {},
}) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            {/* Disabled buttons emit no events; the span keeps the reason reachable. */}
            <Tooltip title={blocker || ""} placement="top" arrow>
                <span>
                    <Button
                        {...buttonProps}
                        disabled={Boolean(blocker)}
                        onClick={() => setOpen(true)}
                    >
                        {hasVideo ? "Reload video" : "Upload video"}
                    </Button>
                </span>
            </Tooltip>
            <ReloadVideoDialog
                open={open}
                onClose={() => setOpen(false)}
                onStarted={(details) => {
                    setOpen(false);
                    toast.success(
                        "The new video is loading. Stem separation starts once it is ready."
                    );
                    onStarted?.(details);
                }}
                projectId={projectId}
                projectName={projectName}
                hasVideo={hasVideo}
                stemSeparationOptions={STEM_SEPARATION_OPTIONS}
                defaultStemSeparationProvider={defaultStemSeparationProvider}
            />
        </>
    );
};

export default ReloadVideoButton;
